import { render, staticRenderFns } from "./DeviceImage.vue?vue&type=template&id=4945514a&scoped=true&"
import script from "./DeviceImage.vue?vue&type=script&lang=js&"
export * from "./DeviceImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945514a",
  null
  
)

export default component.exports